// components/Blog/BlogArticle.jsx

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchArticleBySlug } from "../../Services/Actions/WordpressApi";
import RelatedArticles from "./RelatedArticles";
import ShareBar from "./ShareBar";
import Leadmagnet from "../ReuasbleComponets/leadmagnet";
import { param } from "jquery";

const decodeHtml = (html) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

const BlogArticle = () => {
  const { articles } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  console.log(articles);
  useEffect(() => {
    const fetchBySlug = async () => {
      if (!articles) {
        setError("No post slug provided.");
        setLoading(false);
        return;
      }

      try {
        const fetchedArticle = await fetchArticleBySlug(articles);
        setArticle(fetchedArticle);
        window.scrollTo(0, 0);
      } catch (err) {
        console.error("Error fetching article:", err);
        setError("Failed to load article.");
      } finally {
        setLoading(false);
      }
    };
    fetchBySlug();
  }, [articles]);

  if (loading) return <p>Loading article...</p>;
  if (error) return <p>{error}</p>;

  if (!article) {
    return (
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <h2>Sorry, we couldn’t find that post.</h2>
        <button onClick={() => navigate("/blog")}>
          ← Back to All Blog Posts
        </button>
      </div>
    );
  }

  const articleTitle = decodeHtml(article.title);
  const cleanedContent = article.content
    .replace(/<p>(\s|&nbsp;)*<\/p>/g, "")
    .replace(/(<br\s*\/?>\s*){2,}/gi, "<br />");

  return (
    <>
      <div className="breadcrumb-container">
        <div className="blog-article__breadcrumb">
          <span className="breadcrumb__link" onClick={() => navigate("/blog")}>
            Blog
          </span>
          <span className="breadcrumb__divider">›</span>
          <span
            className="breadcrumb__link"
            onClick={() => navigate(`/blog/${location.search.split("?")?.[1]}`)}
          >
            {article.category}
          </span>
          <span className="breadcrumb__divider">›</span>
          <span className="breadcrumb__static">{articleTitle}</span>
        </div>
      </div>

      <div className="blog-article">
        <div className="blog-article__container">
          {article.image && (
            <img
              src={article.image}
              alt={articleTitle}
              className="blog-article__image"
            />
          )}
          <h1 className="blog-article__title">{articleTitle}</h1>
          <div
            className="blog-article__content"
            dangerouslySetInnerHTML={{ __html: cleanedContent }}
          />
        </div>
      </div>

      <Leadmagnet />
      <ShareBar />
      <RelatedArticles />
    </>
  );
};

export default BlogArticle;
